<template>
  <VDialog v-model="isOpen" width="auto">
    <VCard :width="width" class="align-center text-center pa-8">
      <VIcon :color="color" class="conformation-icon" :icon="iconName" />

      <h2 class="py-3">
        {{ title }}
      </h2>

      <p v-if="description" class="py-3 text-gray-400">
        {{ description }}
      </p>

      <div class="d-flex ga-2 pt-5 w-100">
        <VBtn class="w-50" :color="color" @click="onSubmit">{{
          $t('words.accept')
        }}</VBtn>

        <VBtn
          class="w-50"
          variant="outlined"
          :color="color"
          @click="toggleIsOpen"
          >{{ $t('words.cancel') }}</VBtn
        >
      </div>
    </VCard>
  </VDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VBtn, VCard, VDialog, VIcon } from 'vuetify/components'
import type { Emits, Props } from './BaseConfirmationModal.types'
import { ConfirmationState } from '@/modules/Core/types/model/confirmationModal'

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const isOpen = defineModel<boolean>('modelValue')

const iconName = computed(() => {
  return props.state === ConfirmationState.Logout
    ? 'logoutCircle'
    : props.state === ConfirmationState.Termination
      ? 'termination'
      : props.state === ConfirmationState.Delete
        ? 'deleteCircle'
        : ''
})

function toggleIsOpen() {
  emit('update:isOpen', !isOpen.value)
}

function onSubmit() {
  emit('onSubmit')
  toggleIsOpen()
}
</script>

<style>
.conformation-icon {
  height: 20%;
  width: 20%;
}
</style>
